import { takeLatest, put, call } from 'redux-saga/effects';
import { CORE_API } from '../../config';
import * as CorporateListAction from './action';
import request from '../../components/Utils/httpHelper';
import { AUTH_SERVER } from '../../config'


const token = localStorage.getItem('id_token');
const httpHeaders = {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Accept': 'application/json',
    'Authorization': `Bearer ${token}`
}

export function* analystsList(action) {
    let requestURL = `${AUTH_SERVER}/user/analyst/list`;
    try {
        const result = yield call(request, requestURL, { data: action.data, method: 'GET', headers: httpHeaders });
        yield put(CorporateListAction.getAnalystsListSuccess(result.data));
    } catch (err) {
        yield put(CorporateListAction.getAnalystsListSuccess(err))
    }
}
export function* getAnalystsListSaga() {
    yield takeLatest(CorporateListAction.GET_ANALYSTS_LIST, analystsList);
}

export function* getAccessManagementCorporateList(action) {
    let requestUrl = `${CORE_API}/corporate/filtermodel/list`;
    try {
        const createResult = yield call(request, requestUrl, { method: 'GET', data: '', headers: httpHeaders });
        yield put(CorporateListAction.listCorporateSuccess(createResult.data));
    } catch (err) {
        if (!err.response) {
            yield put(CorporateListAction.listCorporateFailure(false))
        } else {
            yield put(CorporateListAction.listCorporateFailure(err))
        }

    }
}
export function* accessManagementCorporateList(action) {
    yield takeLatest(CorporateListAction.LIST_CORPORATE, getAccessManagementCorporateList);
}

export function* postUsersSelectedCorporates(action) {
    let requestUrl = `${CORE_API}/user/corporate/access`;
    const headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`
    }
    try {
        const createResult = yield call(request, requestUrl, { method: 'POST', data: action.data, headers: headers });
        yield put(CorporateListAction.userSelectedCorporatesSuccess(createResult.data));
    } catch (err) {
        if (!err.response) {
            yield put(CorporateListAction.userSelectedCorporatesFailure(false))
        } else {
            yield put(CorporateListAction.userSelectedCorporatesFailure(err))
        }

    }
}
export function* usersSelectedCorporates(action) {
    yield takeLatest(CorporateListAction.USER_SELECTED_CORPORATES, postUsersSelectedCorporates);
}

export function* fetchUsersCorporates(action) {
    let requestUrl = `${CORE_API}/user/corporate/access/${action.data}`;
    try {
        const createResult = yield call(request, requestUrl, { method: 'GET', data: '', headers: httpHeaders });
        yield put(CorporateListAction.fetchUserCorporatesSuccess(createResult.data));
    } catch (err) {
        if (!err.response) {
            yield put(CorporateListAction.fetchUserCorporatesFailure(false))
        } else {
            yield put(CorporateListAction.fetchUserCorporatesFailure(err))
        }

    }
}
export function* usersCorporates(action) {
    yield takeLatest(CorporateListAction.FETCH_USER_CORPORATES, fetchUsersCorporates);
}